import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import posthog from 'posthog-js';
import './Success.css';

function Success() {
  const [searchParams] = useSearchParams();
  const variant = searchParams.get('variant') || 'unknown';

  useEffect(() => {
    // Track the completed purchase
    posthog.capture('purchase_completed', {
      variant: variant,
      timestamp: new Date().toISOString()
    });
  }, [variant]);

  return (
    <div className="success-container">
      <h1>Thanks for your reservation!</h1>
      <p>We'll keep you posted on our progress.</p>
      <p>If you have any questions, please don't hesitate to reach out to us at founders@symphoniclabs.com</p>
    </div>
  );
}

export default Success; 